export default {
    FORMAT: {
        DEFAULT: '0,0.00',
        INTEGER: '0,0',
        PERCENT: '0.00',
        DEFAULT_WITH_ABR: '0,0.00a',
        INTEGER_WITH_ABR: '0,0a',
    },
};
